<template>
  <div class="nd-breadcrumb" ref="breadcrumbs">
    <NuxtLink
      v-for="item in items"
      :key="item.routeLink"
      :to="item.routeLink"
      :class="getClass(item)">
      <span class="divider" v-if="shouldDisplayDivider(item)"></span>
      {{ item.text }}
    </NuxtLink>
  </div>
</template>

<script lang="ts">
import { BreadcrumbsItem } from '~/helpers/BreadcrumbsBuilder';
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    items: Array<BreadcrumbsItem>
  },
  methods: {
    getClass(item: BreadcrumbsItem): string {
      return (this.items && this.items[this.items?.length - 1] === item) ? 'disabled' : '';
    },

    shouldDisplayDivider(item: BreadcrumbsItem): boolean {
      return item.routeLink !== '/'
    },
  },
});
</script>

<style scoped>
.disabled {
  opacity: 0.5;
  text-decoration: none;
  pointer-events: none;
}

</style>
